import { Injectable } from '@angular/core';
import { Action, State, StateContext, Store } from '@ngxs/store';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { NotificationService } from '../../../../../../common/services';
import {
  AllocationViewDeleteAction,
  AllocationViewDeleteSetInitialState,
} from './allocation-view-delete-action.actions';
import { AllocationViewDeleteActionService } from './allocation-view-delete-action.service';
import { AllocationViewActionBaseState } from '../base';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export interface AllocationViewDeleteActionStateModel {
  loaded: boolean;
}

const initialState: AllocationViewDeleteActionStateModel = {
  loaded: false,
};

@State({
  name: 'allocationViewActionsDelete',
  defaults: initialState,
})
@Injectable()
export class AllocationViewDeleteActionState extends AllocationViewActionBaseState {
  static getLoaded(state: AllocationViewDeleteActionStateModel): boolean {
    return state.loaded;
  }

  constructor(
    private allocationViewDeleteActionService: AllocationViewDeleteActionService,
    notificationService: NotificationService,
    store: Store,
  ) {
    super(notificationService, store);
  }

  @Action(AllocationViewDeleteAction)
  uliDelete(
    ctx: StateContext<AllocationViewDeleteActionStateModel>,
    { payload: { identifier, comment } }: AllocationViewDeleteAction,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.allocationViewDeleteActionService.uliDelete(identifier, comment).pipe(
      map(() => {
        ctx.patchState({ loaded: true });
        this.finishAction('api.uli.success.delete');
      }),
      catchError(({ error }: HttpErrorResponse) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(AllocationViewDeleteSetInitialState)
  setInitialState(ctx: StateContext<AllocationViewDeleteActionStateModel>): void {
    ctx.setState(initialState);
    this.setContainerAfterActionEffectsInitialState();
  }
}
